module.exports = __webpack_public_path__ + "img/29.c18aa4cb.png";